import {
  DEFAULT_LOCALE,
  LOCALE_COOKIE_KEY,
  normalizeLocale,
} from '~/utils/locale'

export default async function ({ isHMR, app, store, params }) {
  if (isHMR) {
    return
  }

  const cookieLocale = app.$cookies.get(LOCALE_COOKIE_KEY)
  const locale = normalizeLocale(params.lang || cookieLocale || store.state.locale || DEFAULT_LOCALE)

  if (app.$loadLanguageAsync) {
    await app.$loadLanguageAsync(locale)
    return
  }

  store.commit('SET_LANG', locale)
  app.i18n.locale = store.state.locale
}
